/**
 * Ukrainian personal-income-tax ladder for private car sales, by the sale's
 * ordinal within the calendar year — ported from the marketplace seller cabinet
 * (`apps/marketplace/.../utils/tax.ts`):
 *
 *   1st sale  →  0% PIT,  0% military levy
 *   2nd sale  →  5% PIT + 5% military levy
 *   3rd+ sale → 18% PIT + 5% military levy
 *
 * An estimate shown before a consignment listing is submitted, not tax advice.
 */
export interface TaxBracket {
  /** 1-based ordinal of the sale within the calendar year. */
  ordinal: number;
  pitPct: number;
  militaryPct: number;
  totalPct: number;
  /** i18n suffix: marketplace.seller.tax.<key>. */
  key: 'sale1' | 'sale2' | 'sale3plus';
}

/** `soldThisYear` must be the server's count (`listings/sales-count`), never a local tally. */
export function computeNextSaleBracket(soldThisYear: number): TaxBracket {
  const ordinal = Math.max(0, Math.floor(soldThisYear)) + 1;
  if (ordinal === 1) return { ordinal, pitPct: 0, militaryPct: 0, totalPct: 0, key: 'sale1' };
  if (ordinal === 2) return { ordinal, pitPct: 5, militaryPct: 5, totalPct: 10, key: 'sale2' };
  return { ordinal, pitPct: 18, militaryPct: 5, totalPct: 23, key: 'sale3plus' };
}
